/* eslint-disable import/prefer-default-export */
import { TFunction } from '@cashew/hooks';
import moment from 'moment';
import {
  CusomersDTOResponseDataType,
  CusomersDTOResponseType,
  CustomerData,
  CustomerDataDTO,
  CustomerDTOType,
  StatusType,
} from './types';

const { api } = require('@cashew/utils');

export const getCustomersInfo = (
  customerId: string | number,
  setStartLoading: (it: boolean) => void,
  setCustomerData: (it: CustomerDataDTO) => void,
  setCountryCode: (it: string) => void,
  t: TFunction
) => {
  setStartLoading(true);
  api
    .get({
      endpoint: `customers/profile/${customerId}`,
    })
    .then((resp: CustomerData) => {
      if (resp.data.length < 1) {
        throw Error(t('customerDetails.api.getInfoError'));
      }
      const data = resp.data[0];
      const countryCode = data?.mobileNumber
        ? data.mobileNumber.slice(0, 4)
        : '';
      setCountryCode(countryCode);
      const mobileNumber = data?.mobileNumber
        ? data?.mobileNumber.slice(4)
        : '';
      if (mobileNumber) data.mobileNumber = mobileNumber;
      setCustomerData(data);
    })
    .finally(() => setStartLoading(false));
};

export const resetKYCAttempts = (
  customerId: string | number,
  setStartKYCLoading: (it: boolean) => void,
  setKYCReseted: (it: boolean) => void
) => {
  setStartKYCLoading(true);
  api
    .patch({
      endpoint: `customers/shufti/${customerId}`,
    })
    .then(() => setKYCReseted(true))
    .finally(() => setStartKYCLoading(false));
};

const pollingIterationsHelper = (
  from: string,
  to: string,
  delay: number
): number => {
  const dateFrom = moment(from).unix();
  const dateTo = moment(to).unix();
  const iterations = Math.ceil((dateTo - dateFrom) / delay);
  return iterations;
};

export const updateCustomerData = (
  customerDTO: CustomerDTOType,
  setDataLoading: (it: boolean) => void,
  setData: (it: CusomersDTOResponseDataType) => void,
  setItemUpdateStatus: (it: StatusType) => void,
  setShowUpdateItemModal: (it: boolean) => void,
  setSaveItem: (it: boolean) => void,
  setItemPollingIterations: (it: number) => void,
  requestDelay: number,
  t: TFunction,
  dispatch: any,
  setBaseCoutryCode?: (it: string) => void
) => {
  setDataLoading(true);

  api
    .post({
      endpoint: 'customers/profile-update-request',
      params: {
        field: customerDTO.type,
        cashewCustomerId: customerDTO.cashewCustomerId,
        emailAddress: customerDTO.emailAddress,
        contactNo: customerDTO.contactNo,
        newValue: customerDTO.newValue,
      },
      headers: {
        Authorization: customerDTO.token,
      },
    })
    .then((response: CusomersDTOResponseType) => {
      setData(response.data);
      setItemUpdateStatus('info');
      setShowUpdateItemModal(true);
      setSaveItem(false);
      setItemPollingIterations(
        pollingIterationsHelper(
          response.data.createdAt,
          response.data.expiryAt,
          requestDelay
        )
      );
      if (setBaseCoutryCode) {
        setBaseCoutryCode(customerDTO.contactNo.slice(0, 4));
      }
    })
    .catch((err: any) => {
      let errorText = err.response.data.message || err.message;

      const { errorCode } = err.response.data;
      if (errorCode === '400.003.024' || errorCode === '400.003.030') {
        errorText = t(`customerDetails.error.${errorCode}`);
      }
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('customerDetails.errorToasterTitle'),
          toasterMessage: errorText,
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      });
    })
    .finally(() => setDataLoading(false));
};
